import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';

import { WhatsAppButton } from '@/components/atoms';
import { SectionHeading } from '@/components/molecules';
import { Section } from '@/components/organisms';

import { regionalCoverage, REGIONAL_WHATSAPP_MESSAGE } from '../content';
import { RegionalCoverageCard } from '../molecules/RegionalCoverageCard';

const TITLE_ID = 'delivery-regional-coverage-title';

/** Wider destinations are enquiry-led and intentionally have no price panel. */
export function RegionalCoverageBand() {
  return (
    <Section tone="muted" pattern="grid" labelledBy={TITLE_ID}>
      <Stack spacing={{ xs: 7, md: 9 }}>
        <SectionHeading
          id={TITLE_ID}
          eyebrow={regionalCoverage.eyebrow}
          title={regionalCoverage.title}
          lede={regionalCoverage.lede}
        />

        <Grid container spacing={{ xs: 4, md: 5 }}>
          {regionalCoverage.regions.map((region, index) => (
            <Grid key={region.title} size={{ xs: 12, md: 6 }}>
              <RegionalCoverageCard region={region} index={index} />
            </Grid>
          ))}
        </Grid>

        <WhatsAppButton message={REGIONAL_WHATSAPP_MESSAGE}>
          {regionalCoverage.action}
        </WhatsAppButton>
      </Stack>
    </Section>
  );
}
